/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SkillList { 
    readonly id: string;
    /**
     * Zadejte název dovednosti.
     */
    title: string;
    readonly areaName: string;
    readonly areaColor: string;
    readonly subareaName: string;
    readonly subareaColor: string;
    readonly areaId: string;
    readonly subareaId: string;
    readonly isWatched: boolean;
    readonly childrenWatchedCount: number;
    readonly level1DoneCount: number;
    readonly level2DoneCount: number;
    readonly level3DoneCount: number;
    readonly touchCount: number;
    readonly firstLevelDone: boolean;
    readonly secondLevelDone: boolean;
    readonly thirdLevelDone: boolean;
    /**
     * Zadejte popis kompetence na první úrovni. (3-4 let)
     */
    firstLevelDescription?: string;
    /**
     * Zadejte popis kompetence na druhé úrovni. (4-5 let)
     */
    secondLevelDescription?: string;
    /**
     * Zadejte popis kompetence na třetí úrovni. (5-6 let)
     */
    thirdLevelDescription?: string;
    readonly isCompleted: boolean;
}